import classNames from 'classnames/bind';

import styles from './index.module.scss';

const cx = classNames.bind(styles);

const S03 = () => {
  return (
    <section className={cx('container')}>
      <div className={cx('header')}>
        <h1 className={cx('title')}>SAFE</h1>
      </div>
      <article className={cx('content')}>
        {/* <p className={cx('subtitle')}>첫 번째 약속! 걱정없는 안심 성분</p> */}
        <h4 className={cx('title')}>SAFE</h4>
        <p className={cx('desc')}>
          LEVRAI cares for your family’s skin,
          <br />
          using only the purest and safest ingredients.
        </p>
        <div className={cx('feature')}>
          <div className={cx('veganLogo')}>
            <img src={require('../../../asset/images/about/s03-vegan_logo.png')} alt="eve VEGAN" />
          </div>
          <div className={cx('info')}>
            <h5>Certified by EVE Vegan (France)</h5>
            <p>
              Authentic vegan products made with <br />
              plant-based ingredients in their natural form.
            </p>
          </div>
        </div>
        <div className={cx('feature')}>
          <div className={cx('veganLogo')}>
            <img src={require('../../../asset/images/about/s03-dermatest.png')} alt="eve VEGAN" />
          </div>
          <div className={cx('info')}>
            <h5>Rated &ldquo;Excellent&rdquo; by Dermatest (Germany)</h5>
            <p>
              Dermatologically tested and certified <br />
              for sensitive skin care.
            </p>
          </div>
        </div>
        <div className={cx('feature')}>
          <ul className={cx('images')}>
            <li>
              <img src={require('../../../asset/images/about/s03-safe-01.png')} alt="CLEAN &amp; NATURAL TREATMENT" />
            </li>
            <li>
              <img src={require('../../../asset/images/about/s03-safe-02.png')} alt="CLEAN &amp; NATURAL TREATMENT" />
            </li>
            <li>
              <img src={require('../../../asset/images/about/s03-safe-03.png')} alt="CLEAN &amp; NATURAL TREATMENT" />
            </li>
          </ul>
          <div className={cx('info')}>
            <h5>Naturally derived ingredients</h5>
            <p>
              Clean and gentle formulations <br />
              safe for the whole family.
            </p>
          </div>
        </div>
      </article>
    </section>
  );
};

export default S03;
